// third-party
import { FormattedMessage } from 'react-intl';

// assets
import HomeOutlined from '@ant-design/icons/HomeOutlined';

// type
import { NavItemType } from '@trendiolive/trendio-selfcare-ui-kit';

// icons
const icons = { HomeOutlined };

// ==============================|| MENU ITEMS - HOME PAGE ||============================== //

const home: NavItemType = {
  id: 'home',
  title: <FormattedMessage id="home" />,
  type: 'group',
  url: '/home',
  icon: icons.HomeOutlined
};

export default home;
